import { ComboBox, DropDownList, MultiSelect ,MultiColumnComboBox ,AutoComplete} from '@progress/kendo-react-dropdowns';
import { filterBy } from "@progress/kendo-data-query";
import React,{ useState, useEffect,forwardRef  } from 'react';

export const SBADropDown = (props) => {
  const { data, value, onChange, textField, valueField, disable, filterable, onFilterChange, className, ...rest } = props;
  const [ddData, setDDdata] = useState(data);
  const [ddlvalue, setddlvalue] = useState(value);
  const [DDStatus,setDDStatus]=useState(false)

  useEffect(() => {
    setDDdata(data);
    setddlvalue(value);
  }, [props]);
  useEffect(()=>{
    setDDStatus(disable);
  },[disable])

  const onchange = (e) => {
    setddlvalue(e.value);
    if (onChange) {
      onChange(e)
    }
  }
  const filteredData = (filter) => {
    return filterBy(data, filter);
  };

  const filterChange = async (e) => {
    if (onFilterChange) {
      onFilterChange(e);
    }
    setDDdata(filteredData(e.filter));
  };
  return (
    <DropDownList
      className={className + ` SBADropDown`}
      data={ddData}
      value={ddlvalue}
      onChange={onchange}
      textField={textField}
      dataItemKey={valueField}
      disabled={DDStatus}
      filterable={filterable}
      onFilterChange={filterChange}
      clearButton={false}
      {...rest}
    />
  );

};

export const SBAComboBox = forwardRef((props,ref) => {

  const { data, value, onChange, textField, valueField, disabled, filterable, onFilterChange,popupSettings, className,onKeyUp, ...rest } = props;
  const [ddData, setDDdata] = useState(data);

  useEffect(() => {
    setDDdata(data);
  }, [props]);

  const onchange = (e) => {
    if (onChange) {
      onchange(e)
    }
  }

  const filteredData = (filter) => {
    return filterBy(data, filter);
  };

  const filterChange = async (e) => {
    if (onFilterChange) {
      onFilterChange(e);
    }
    e?.filter &&  setDDdata(filteredData(e?.filter));
  };
  return (
    <ComboBox
      ref={ref}
      className={className + ` SBADropDown`}
      data={ddData}
      value={value}
      onChange={onChange}
      textField={textField}
      dataItemKey={valueField}
      disabled={disabled}
      filterable={true}
      onFilterChange={filterChange}
      clearButton={false}
      popupSettings={popupSettings}
      {...rest}
    />
  );
});


export const SBAMultiSelect = (props) => {
  const { data, value, onChange, textField, dataItemKey, disabled, filterable, onFilterChange, className, defaultValue,tags, ...rest } = props;
  const [ddData, setDDdata] = useState(data);
  const [ddlvalue, setddlvalue] = useState(value);
  useEffect(() => {
    setDDdata(data);
    setddlvalue(value);
  }, [props]);

  const onchange = (e) => {
    setddlvalue(e.value);
    if (onChange) {
      onChange(e);
    }
  };
  const filteredData = (filter) => {
    return filterBy(data, filter);
  };
  const filterChange = (e) => {
    if (onFilterChange) {
      onFilterChange(e);
    }
    setDDdata(filteredData(e.filter));
  };
 
  return (
    <MultiSelect
      className={className + ` SBADropDown`}
      data={ddData}
      value={ddlvalue}
      onChange={onchange}
      textField={textField}
      dataItemKey={dataItemKey}
      disabled={disabled}
      filterable={true}
      clearButton={false}
      multi={true}
      defaultValue={defaultValue}
      onFilterChange={filterChange}
      tags={tags}
      {...rest}
    />
  );
};


export const SBAMultiSelectCheck = (props) => {
  const { data, value, onChange, textField, dataItemKey, disabled, filterable, onFilterChange, className, defaultValue,tags, ...rest } = props;

  const [ddData, setDDdata] = useState(data);
  const [isOpen,setIsOpen]=useState(false);
  
  const [ddlvalue, setddlvalue] = useState(value);
  
  useEffect(() => {
    setDDdata(data);
    setddlvalue(value);
  }, [props]);

  const onchange = (e) => {
    setddlvalue(e.value);
    if (onChange) {
      onChange(e);
    }
  };
  const filteredData = (filter) => {
    return filterBy(data, filter);
  };
  const filterChange = (e) => {
    setDDdata(filteredData(e.filter));
    if (onFilterChange) {
      onFilterChange(e);
    }
  };
  const itemRender = (li, itemProps) => {
    const itemChildren = (
      <div className='w-100 d-flex'>
        {li.props.children}
        <input
          type="checkbox"
          //name={itemProps.dataItem}
          checked={itemProps.selected}
          // onChange={(e) => {
          //   e.stopPropagation();
          //   itemProps.onClick(itemProps.index, e);
          // }}
          className='ms-auto'
        />
      </div>
    );
    return React.cloneElement(li, li.props, itemChildren);
  };
  const onBlur=()=>{
    setIsOpen(false);
  };
  const onFocus=()=>{
    setIsOpen(true);
  }
 
  return (
    <MultiSelect
      itemRender={itemRender}
      className={className + ` SBADropDown`}
      data={ddData}
      value={ddlvalue}
      onChange={onchange}
      textField={textField}
      dataItemKey={dataItemKey}
      disabled={disabled}
      filterable={true}
      clearButton={false}
      multi={true}
      defaultValue={defaultValue}
      onFilterChange={filterChange}
      tags={tags}
      // onBlur={onBlur}
      // opened={isOpen}
      onFocus={onFocus}
      {...rest}
    />
  );
};


export const SBAMultiColumnComboBox = (props) => {
    
   
  const { data, value , onChange, textField,columns, disabled, filterable, onFilterChange, className, defaultValue,placeholder, ...rest } = props;
  const [ddData, setDDdata] = useState(data);
  const [ddlvalue, setddlvalue] = useState(value);
    const [ddlcolumn, setddlcolumn] = useState(columns);
  useEffect(() => {
    setDDdata(data);
      setddlvalue(value);
      setddlcolumn(columns);
  }, [props]);

    const onchange = (e) => {
    setddlvalue(e.value);
    if (onChange) {
      onChange(e);
    }
  };

  const filteredData = (filter) => {
    return filterBy(data, filter);
  };

  const filterChange = (e) => {
    if (onFilterChange) {
      onFilterChange(e);
    }
    setDDdata(filteredData(e.filter));
  };
 
  return (
    <MultiColumnComboBox
      className={className + ` SBADropDown`}
      columns={ddlcolumn}
      data={ddData}
      value={ddlvalue}
      onChange={onchange}
      textField={textField}
      disabled={disabled}
      filterable={true}
      clearButton={false}
      defaultValue={defaultValue}
      onFilterChange={filterChange}
      placeholder={placeholder}
      {...rest}
    />
  );
}


export const SBAAutoComplete = (props) => {
  const { data, value, placeholder,filter,onChange, textField, valueField, disabled, filterable, onFilterChange,popupSettings, className,onKeyUp,onSelect,suggest,onClear,clear,clearButton, ...rest } = props;
  const [ddData, setDDdata] = useState(data);

  useEffect(() => {
    setDDdata(data);
  }, [data]);

  const handleChange = (event) => {
    if(onChange)
    {
      onChange(event);
    }
  }
  const handleSelect=(event)=>{
    if(onSelect)
    {
      onSelect(event);
    }
  }
  const handleClear=(event)=>{
    if(onClear)
    {
      onClear(event)
    }
  }

  return (
    <div>
      <AutoComplete
       className={className + ` SBADropDown`}
        data={ddData}
        onChange={handleChange}
        placeholder={placeholder}
        filter={filter}
        textField={textField}
        dataItemKey={valueField}
        popupSettings={popupSettings}
        onSelect={handleSelect}
        suggest={suggest}
        onClear={handleClear}
        clearButton={clearButton}
        {...rest}
      />
    </div>
  );
}
export const SBAMulticolumnCheck = (props) => {
  const { data, value, onChange, textField, dataItemKey, disabled, filterable, onFilterChange, className, defaultValue,tags, ...rest } = props;
  
  const [ddData, setDDdata] = useState(data);
  const [isOpen,setIsOpen]=useState(false);
  
  const [ddlvalue, setddlvalue] = useState(value);
  
  useEffect(() => {
    setDDdata(data);
    setddlvalue(value);
  }, [props]);
  
  const onchange = (e) => {
    setddlvalue(e.value);
    if (onChange) {
      onChange(e);
    }
  };
  const filteredData = (filter) => {
    return filterBy(data, filter);
  };
  const filterChange = (e) => {
    setDDdata(filteredData(e.filter));
    if (onFilterChange) {
      onFilterChange(e);
    }
  };
  const itemRender = (li, itemProps) => {
    const type = itemProps.dataItem.ActivityEntityType;
    const spanStyles = type === "Account" ? { color: "#0095F6" } : { color: "#5A89AE" };
    const icon= type!=="Account" ? < ><img title={type} className='SBA_hand' style={{ width: "24px" ,height : "24px"  }}  src='/images/contact.svg'/></> :< ><img  title={type} className='SBA_hand' style={{ width: "24px" ,height : "24px"  }}  src='/images/account.svg'/></>;
    const itemChildren = (
      <div className='w-100 d-flex'>
        <span style={spanStyles}>{icon}  {itemProps.dataItem.EntityName} </span>
        <input
          type="checkbox"
          //name={itemProps.dataItem}
          checked={itemProps.selected}
          onChange={(e) => itemProps.onClick(itemProps.index, e)}
          className='ms-auto'
        />
      </div>
    );
    return React.cloneElement(li, li.props, itemChildren);
  };
  const onBlur=()=>{
    setIsOpen(false);
  };
  const onFocus=()=>{
    setIsOpen(true);
  }
  
  return (
    <MultiSelect
      itemRender={itemRender}
      className={className + ` SBADropDown`}
      data={ddData}
      value={ddlvalue}
      onChange={onchange}
      textField={textField}
      dataItemKey={dataItemKey}
      disabled={disabled}
      filterable={true}
      clearButton={false}
      multi={true}
      defaultValue={defaultValue}
      onFilterChange={filterChange}
      tags={tags}
      onBlur={onBlur}
      opened={isOpen}
      onFocus={onFocus}
      {...rest}
    />
  );
  }